import React from 'react';

import styles from './BenifitsAndRestrictionsModal.module.scss';

import Button from '../../components/Button/Button';
import config from '../../config/config';

const BenifitsAndRestrictionsModal = ({ onClose }) => {
  return (
    <div className={styles.container}>
      <div className="modal-title">
        Auto-RMD Tool Benefits &amp; Restrictions
      </div>
      <div className={styles.row}>
        <div className={styles.column} style={{ marginRight: 30 }}>
          <div className={styles.subtitle}>Benefits</div>
          <ul>
            <li>Replaces an auto-sell and recalculates your RMD every year</li>
            <li>
              Includes option for proportional distribution method which
              maintains asset allocation over time
            </li>
            <li>Auto-RMD can be edited anytime</li>
            <li>
              RMD will be withdrawn automatically each year to prevent the IRS
              penalty for missed or late distributions
            </li>
          </ul>
        </div>
        <div className={styles.column}>
          <div className={styles.subtitle}>Restrictions</div>
          <ul>
            <li>Cannot add a new investment while setting up Auto-RMD</li>
            <li>Cannot add a new bank</li>
            <li>Cannot process deferred or missed RMDs</li>
            <li>Cannot withdraw more than RMD amount</li>
            <li>
              RMD can only have one distribution method (eg, cannot withdraw +
              reinvest)
            </li>
            <li>
              Cannot complete Qualified Charitable Distributions. To complete
              online, please navigate to our
              <a
                className={styles['modal-link']}
                href={`${config.url}/usis/transactions/qcd/landing`}
                target="_self"
                rel="noopener noreferrer"
              >
                (Make a QCD Online)
              </a>
            </li>
            <li>
              Cannot establish an Auto-RMD on Workplace Retirement plans,
              ActivePlus Portfolios, Inherited IRAs, Brokerage Advantage, or
              Retirement Advisory Service accounts.
            </li>
          </ul>
        </div>
      </div>
      <div className={styles['footer-text']}>
        Some restricted actions may be performed;{' '}
        <a
          className={'error-link'}
          rel="noopener noreferrer"
          href={`${config.url}/personal-investing/help/contact/index.html`}
          target="_blank"
        >
          Contact us
        </a>{' '}
        to learn more
      </div>
      <div className={styles.button} onClick={onClose}>
        <Button id="benifits-modal-close" type="primary">
          Close
        </Button>
      </div>
    </div>
  );
};

export default BenifitsAndRestrictionsModal;
